<!-- <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()">

    @switch (paymentStep()) {
    @case ('selection') {
    <div class="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 z-10">
      <div class="flex justify-between items-center">
        <div>
          <h3 class="text-xl font-bold text-gray-800">
            {{ title() ? (title() | translate) : ('PAYMESTR0036' | translate) }}
          </h3>
          @if (amount() > 0) {
          <div class="text-3xl font-extrabold text-gray-900 mt-2">
            {{ amount() | number:'1.0-0' }}<span class="text-lg ml-1">{{ 'USERMAG0048' | translate }}</span>
          </div>
          }
        </div>
        <button (click)="cancel()"
          class="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>
    </div>

    <div class="p-8">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        @for (method of paymentMethods(); track method.id) {
        @if (isMethodEnabled(method)) {
        <button (click)="selectMethod(method.id)"
          class="bg-white rounded-2xl border-2 border-gray-100 p-6 flex flex-col justify-between hover:shadow-lg transition-all group text-left relative overflow-hidden h-32 md:h-40"
          [class]="getColorClasses(method.color, true)">
          <div class="flex justify-between items-start relative z-10">
            <div>
              <span class="text-2xl font-bold text-gray-800 block mb-1">{{ method.titleKey | translate }}</span>
              @if (method.subtitleKey) {
              <span class="text-sm text-gray-500 font-medium">{{ method.subtitleKey | translate }}</span>
              }
            </div>
            <img [src]="method.icon" width="50" height="50" [alt]="method.titleKey">
          </div>
          <div
            class="flex items-center gap-2 mt-auto text-xs font-bold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity"
            [class]="getColorClasses(method.color, false)">
            {{ 'pos.paymentMethods.proceed' | translate }}
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m9 18 6-6-6-6" />
            </svg>
          </div>
        </button>
        }
        }
      </div>
    </div>

    <div class="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-8 py-4 flex justify-end gap-3">
      <button (click)="cancel()"
        class="px-6 py-2.5 bg-white border border-gray-300 text-gray-700 text-sm font-bold rounded-lg hover:bg-gray-50 transition-colors">
        {{ 'SYSMESER0010' | translate }}
      </button>
    </div>
    }

    @case ('card') {
    <div class="p-8 flex flex-col items-center min-h-[600px]">
      <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
        <div class="text-left">
          <div class="text-base font-bold text-gray-900 mb-1">{{ 'PAYMESTR0036' | translate }}</div>
          <div class="text-3xl font-extrabold text-gray-900">{{ amount() | number:'1.0-0' }}{{ 'USERMAG0048' | translate
            }}</div>
        </div>
        <div class="flex gap-6">
          <div class="text-center">
            <div class="text-base font-bold text-gray-900 mb-1">{{ 'PAYMESTR0050' | translate }}</div>
            <input type="number" [ngModel]="installmentCount()" (ngModelChange)="installmentCount.set($event)" min="0"
              class="w-[100px] h-[50px] text-center text-xl font-bold border-2 border-gray-300 rounded-lg px-2">
          </div>
          <div class="text-center">
            <div class="text-base font-bold text-gray-900 mb-1">{{ 'PAYMESTR0015' | translate }}</div>
            <div class="text-3xl font-extrabold text-indigo-600">{{ amount() | number:'1.0-0' }}{{ 'USERMAG0048' |
              translate }}</div>
          </div>
        </div>
      </div>

      <div class="flex-1 flex items-center justify-center mb-12">
        <div class="w-32 h-48 border-4 border-black rounded-2xl flex flex-col items-center p-2 bg-white shadow-lg">
          <div class="w-full h-16 bg-gray-100 rounded mb-2 flex items-center justify-center">
            <div class="w-12 h-8 border-2 border-black rounded flex items-center justify-center">
              <div class="w-8 h-1 bg-black rounded-full"></div>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-1 mb-2">
            @for(i of [1,2,3,4,5,6,7,8,9]; track i) {<div class="w-2 h-2 bg-black rounded-full"></div>}
          </div>
          <div class="w-20 h-8 border-t-2 border-black mt-auto flex justify-center">
            <div class="w-12 h-16 bg-white border-2 border-black rounded-b-lg -mt-4 flex justify-center pt-2">
              <div class="w-1 h-8 bg-black mx-1"></div>
              <div class="w-4 h-8 bg-black/20 mx-1"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-4 w-full max-w-[600px]">
        <button (click)="backToSelection()"
          class="px-8 py-3 bg-gray-500 text-white font-bold rounded-lg hover:bg-gray-600">
          {{ 'SYSMESER0010' | translate }}
        </button>
        <button (click)="processPayment()"
          class="flex-1 h-[72px] bg-red-600 text-white text-2xl font-bold rounded-lg shadow-lg hover:bg-red-700">
          {{ 'PAYMESTR0014' | translate }}
        </button>
      </div>
    </div>
    }

    @case ('cash') {
    <div class="p-8 flex flex-col items-center min-h-[600px]">
      <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
        <div class="text-left">
          <div class="text-base font-bold text-gray-900 mb-1">{{ 'PAYMESTR0002' | translate }}</div>
          <div class="text-3xl font-extrabold text-gray-900">{{ amount() | number:'1.0-0' }}{{ 'USERMAG0048' | translate
            }}</div>
        </div>
        <div class="text-right">
          <div class="text-base font-bold text-gray-900 mb-1">{{ 'PAYMESTR0019' | translate }}</div>
          <input type="number" [ngModel]="receivedAmount()" (ngModelChange)="receivedAmount.set($event)"
            [min]="amount()"
            class="text-3xl font-extrabold text-emerald-600 w-[250px] h-[60px] border-2 border-gray-300 rounded-lg px-4 text-right">
        </div>
      </div>

      <div class="flex-1 flex items-center justify-center mb-12">
        <div
          class="w-32 h-40 border-4 border-black rounded-lg bg-white flex flex-col items-center pt-4 relative shadow-lg">
          <div
            class="w-12 h-12 rounded-full border-2 border-orange-400 flex items-center justify-center mb-2 bg-orange-100">
            <span class="font-bold text-lg text-black">₩</span>
          </div>
          <div class="w-16 h-1 bg-blue-300 rounded mb-1"></div>
          <div class="w-16 h-1 bg-blue-300 rounded mb-3"></div>
          <div class="w-full h-8 border-t-4 border-black mt-auto rounded-b-lg"></div>
          <div
            class="absolute -left-2 top-8 w-4 h-8 bg-white border-l-4 border-t-4 border-b-4 border-black rounded-l-lg">
          </div>
        </div>
      </div>

      <div class="flex gap-4 w-full max-w-[700px]">
        <button (click)="backToSelection()"
          class="px-8 py-3 bg-gray-500 text-white font-bold rounded-lg hover:bg-gray-600">
          {{ 'SYSMESER0010' | translate }}
        </button>
        <button (click)="processPayment({type: 'Cash'})"
          class="flex-1 h-[72px] bg-red-600 text-white text-xl font-bold rounded-lg shadow-lg hover:bg-red-700">
          {{ 'PAYMESTR0020' | translate }}
        </button>
      </div>
    </div>
    }

    @case ('easypay') {
    <div class="p-8 flex flex-col items-center min-h-[600px]">
      <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
        <div class="text-left">
          <div class="text-base font-bold text-gray-900 mb-1">{{ 'PAYMESTR0036' | translate }}</div>
          <div class="text-3xl font-extrabold text-gray-900">{{ amount() | number:'1.0-0' }}{{ 'USERMAG0048' | translate
            }}</div>
        </div>
        <div class="text-right">
          <div class="text-base font-bold text-gray-900 mb-1">{{ 'PAYMESTR0016' | translate }}</div>
          <div class="text-3xl font-extrabold text-amber-600">{{ amount() | number:'1.0-0' }}{{ 'USERMAG0048' |
            translate }}</div>
        </div>
      </div>

      <div class="flex-1 flex items-center justify-center mb-12">
        <div
          class="w-32 h-56 border-4 border-black rounded-3xl bg-white flex flex-col items-center justify-center relative shadow-lg">
          <div class="absolute top-2 w-8 h-1 bg-black rounded-full"></div>
          <div class="w-24 h-16 border-2 border-black rounded-lg flex flex-col justify-end p-1 relative bg-white z-10">
            <div class="w-full h-2 bg-black rounded-sm mb-1"></div>
          </div>
          <div class="absolute bottom-4 w-4 h-4 border-2 border-black rounded-full"></div>
          <div
            class="absolute top-20 -right-6 w-20 h-12 bg-white border-2 border-black rounded-lg rotate-[-10deg] flex flex-col p-1 z-0">
            <div class="w-full h-2 bg-black mt-1"></div>
          </div>
        </div>
      </div>

      <div class="flex gap-4 w-full max-w-[600px]">
        <button (click)="backToSelection()"
          class="px-8 py-3 bg-gray-500 text-white font-bold rounded-lg hover:bg-gray-600">
          {{ 'SYSMESER0010' | translate }}
        </button>
        <button (click)="processPayment()"
          class="flex-1 h-[72px] bg-red-600 text-white text-2xl font-bold rounded-lg shadow-lg hover:bg-red-700">
          {{ 'PAYMESTR0018' | translate }}
        </button>
      </div>
    </div>
    }
    }
  </div>
</div> -->
<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">

  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()">
    <div class="flex justify-end h-1">
      <button (click)="cancel()" class="p-3 fw-600">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="flex-1 overflow-y-auto p-8 h-full flex flex-col">
      @if(paySuccess()) {
      <div
        class="p-8 flex flex-col h-full items-center justify-center border-4 border-[#5D5D5D] m-4 rounded-2xl relative">
        <div class="text-center mb-12">
          <h2 class="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">{{
            'PAYMESTR0029' | translate }}</h2>
          <p class=" md: text-gray-500 font-medium">{{ 'PAYMESTR0030' | translate:
            {countdown: countdown()} }}</p>
        </div>
        <div class="mb-16">
          <div class="w-32 h-40 border-4 border-black rounded-lg flex flex-col items-center pt-6 relative">
            <div class="w-20 h-1 bg-blue-300 rounded mb-2"></div>
            <div class="w-20 h-1 bg-blue-300 rounded mb-2"></div>
            <div class="w-20 h-1 bg-blue-300 rounded mb-2"></div>
            <div
              class="absolute -left-2 top-6 w-4 h-8 bg-white border-l-4 border-t-4 border-b-4 border-black rounded-l-lg">
            </div>
            <div class="w-full h-8 border-t-4 border-black mt-auto rounded-b-lg"></div>
          </div>
        </div>
        <button (click)="paymentSuccess()"
          class="w-full max-w-[400px] h-[72px] bg-[#5D5D5D] text-white  font-bold rounded shadow-lg hover:bg-[#4a4a4a] transition-all active:scale-95">{{
          'PAYMESTR0031' | translate }}</button>
      </div>
      }
      @else {
      @switch (paymentStep()) {
      @case ('selection') {
      <div class="flex-1 min-h-0">
        <div
          class="flex flex-col md:flex-row justify-between items-center border-b-2 border-gray-100 pb-8 mb-8 gap-4 md:gap-0">
          <div class="text-center flex-1 w-full border-b md:border-b-0 md:border-r border-gray-200 pb-4 md:pb-0">
            <div class=" font-bold text-gray-500 mb-2">{{ 'PAYMESTR0002' | translate }}
            </div>
            <div class="fs-26 fw-600 text-gray-900">{{ amount() |
              number }} {{'USERMAG0048' | translate}}</div>
          </div>
          <div class="text-center flex-1 w-full border-b md:border-b-0 md:border-r border-gray-200 pb-4 md:pb-0">
            <div class=" font-bold text-gray-500 mb-2">{{ 'PAYMESTR0003' | translate }}
            </div>
            <div class="fs-26 fw-600 text-gray-900">{{ amount() |
              number }} {{'USERMAG0048' | translate}}</div>
          </div>
          <div class="text-center flex-1 w-full">
            <div class=" font-bold text-gray-500 mb-2">{{ 'PAYMESTR0004' | translate }}
            </div>
            <div class="fs-26 fw-600 text-gray-900">{{ amount() |
              number }} {{'USERMAG0048' | translate}}</div>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          @for (method of paymentMethods(); track method.id) {
          @if (isMethodEnabled(method)) {
          <button (click)="selectMethod(method.id)"
            class="bg-white rounded-2xl border-2 border-gray-100 p-6 flex flex-col justify-between hover:shadow-lg transition-all group text-left relative overflow-hidden h-32 md:h-40"
            [class]="getColorClasses(method.color, true)">
            <div class="flex justify-between items-start relative z-10">
              <div>
                <span class="text-2xl font-bold text-gray-800 block mb-1">{{ method.titleKey | translate }}</span>
                @if (method.subtitleKey) {
                <span class="text-sm text-gray-500 font-medium">{{ method.subtitleKey | translate }}</span>
                }
              </div>
              <img [src]="method.icon" width="50" height="50" [alt]="method.titleKey">
            </div>
          </button>
          }
          }
        </div>
      </div>
      }
      @case('card') {
      <div class=" flex flex-col h-full items-center">
        <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
          <div class="text-left">
            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0036' |
              translate }}</div>
            <div class="fs-26 fw-600 text-gray-900">{{ amount() |
              number }} {{ 'USERMAG0048' | translate}}</div>
          </div>

          <div class="text-right flex gap-4 ">
            <div class="text-center">
              <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0050' |
                translate }}</div>
              <div class="font-extrabold text-gray-900">
                <input type="text" class="w-[100px] h-[40px] fs-26 fw-600" pInputText min="0"
                  [ngModel]="installmentCount()" (input)="onInputMonCNT($event)" (keydown)="onKeyDownMonCNT($event)">
              </div>
            </div>
            <div class="text-center">
              <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0015' |
                translate }}</div>
              <input type="text" class="w-[200px] h-[40px] fs-26 fw-600" pInputText min="0"
                [value]="(amount() | number) + ' ' + ('USERMAG0048'| translate)" disabled>
              <!-- <div class=" text-gray-900 fs-26 fw-600">{{ amount() |
                                    number }}{{'USERMAG0048' | translate}}</div> -->
            </div>
          </div>
        </div>
        <div class="flex-1 flex items-center justify-center mb-12 p-8">
          <div class="relative">
            <div class="w-32 h-48 border-4 border-black rounded-2xl flex flex-col items-center p-2 bg-white">
              <div class="w-full h-16 bg-gray-100 rounded mb-2 flex items-center justify-center">
                <div class="w-12 h-8 border-2 border-black rounded flex items-center justify-center">
                  <div class="w-8 h-1 bg-black rounded-full"></div>
                </div>
              </div>
              <div class="grid grid-cols-3 gap-1 mb-2">@for(i of [1,2,3,4,5,6,7,8,9]; track i) {<div
                  class="w-2 h-2 bg-black rounded-full"></div>}</div>
              <div class="w-20 h-8 border-t-2 border-black mt-auto flex justify-center">
                <div class="w-12 h-16 bg-white border-2 border-black rounded-b-lg -mt-4 flex justify-center pt-2">
                  <div class="w-1 h-8 bg-black mx-1"></div>
                  <div class="w-4 h-8 bg-black/20 mx-1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex gap-4 w-full justify-center">
          <button (click)="backToSelection()"
            class="px-8 py-3 bg-gray-500 text-white font-bold rounded-lg hover:bg-gray-600">
            {{ 'SYSMESER0010' | translate }}
          </button>
          <button (click)="processPayment()"
            class="w-full max-w-[400px] h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
            'PAYMESTR0014' | translate }}</button>
        </div>
      </div>
      }
      @case('cash') {
      <div class="flex flex-col h-full items-center">
        <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
          <div class="text-left">
            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0002' |
              translate }}</div>
            <div class="fs-26 fw-600 text-gray-900">{{ amount() |
              number }} {{'USERMAG0048' | translate}}</div>
          </div>
          <div class="text-right">
            <div class="flex gap-6">
              <div>
                <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0019' |
                  translate }}</div>
                <p-inputnumber styleClass="w-[200px] h-[40px]" inputId="integeronly" [ngModel]="receivedAmount()"
                  (ngModelChange)="changereceivedAmount($event)" inputStyleClass="fs-26 fw-600 w-[200px] h-[40px]" />
              </div>

              <div>
                <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0070' |
                  translate }}</div>
                <p-inputnumber styleClass="w-[200px] h-[40px]" inputId="integeronly" [ngModel]="Change_AMT" disabled
                  inputStyleClass="fs-26 fw-600 w-[200px] h-[40px]" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 flex items-center justify-center mb-12 p-8">
          <div class="relative">
            <div class="w-32 h-40 border-4 border-black rounded-lg bg-white flex flex-col items-center pt-4 relative">
              <div
                class="w-12 h-12 rounded-full border-2 border-orange-400 flex items-center justify-center mb-2 bg-orange-100">
                <span class="font-bold  text-black">₩</span>
              </div>
              <div class="w-16 h-1 bg-blue-300 rounded mb-1"></div>
              <div class="w-16 h-1 bg-blue-300 rounded mb-3"></div>
              <div class="w-full h-8 border-t-4 border-black mt-auto rounded-b-lg"></div>
              <div
                class="absolute -left-2 top-8 w-4 h-8 bg-white border-l-4 border-t-4 border-b-4 border-black rounded-l-lg">
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row gap-4 md:gap-6 w-full max-w-[600px] justify-center p-8">
          <button (click)="backToSelection()"
            class="px-8 py-3 bg-gray-500 text-white font-bold rounded-lg hover:bg-gray-600">
            {{ 'SYSMESER0010' | translate }}
          </button>
          <button (click)="processPayment(paymentType.Cash)"
            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">
            {{'PAYMESTR0020' | translate }}</button>
        </div>
      </div>
      }
      @case('easypay') {
      <div class="flex flex-col h-full items-center">
        <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
          <div class="text-left">
            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0036' |
              translate }}</div>
            <div class="fs-26 fw-600 text-gray-900">{{ amount() |
              number }} {{'USERMAG0048'| translate}}</div>
          </div>
          <div class="text-right">
            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0016' |
              translate }}</div>
            <input type="text" class="w-[200px] h-[40px] fs-26 fw-600" pInputText min="0"
              [value]="(amount() | number) + ' ' + ('USERMAG0048'| translate)" disabled>
          </div>
        </div>
        <!-- <div class="flex justify-center fs-16 fw-600">
          {{'PAYMESTR0051' | translate}}: {{selectedEasyPayment?.comM_D_NM}}
        </div>
        <div class="flex-1 flex items-center justify-center mb-12 p-8">
          <div class="relative">
            <div
              class="w-32 h-56 border-4 border-black rounded-3xl bg-white flex flex-col items-center justify-center relative">
              <div class="absolute top-2 w-8 h-1 bg-black rounded-full"></div>
              <div
                class="w-24 h-16 border-2 border-black rounded-lg flex flex-col justify-end p-1 relative bg-white z-10">
                <div class="w-full h-2 bg-black rounded-sm mb-1"></div>
              </div>
              <div class="absolute bottom-4 w-4 h-4 border-2 border-black rounded-full"></div>
              <div
                class="absolute top-20 -right-6 w-20 h-12 bg-white border-2 border-black rounded-lg rotate-[-10deg] flex flex-col p-1 z-0">
                <div class="w-full h-2 bg-black mt-1"></div>
              </div>
            </div>
          </div>
        </div> -->
          <div class="flex justify-between fw-700 items-center h-full fs-20">
          COMING SOON!!!
        </div>
        <div class="flex flex-col md:flex-row gap-4 md:gap-6 w-full max-w-[600px] justify-center p-8">
          <button (click)="backToSelection()"
            class="px-8 py-3 bg-gray-500 text-white font-bold rounded-lg hover:bg-gray-600">
            {{ 'SYSMESER0010' | translate }}
          </button>
          <!-- <button (click)="visibleEasypayment = true"
            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
            'PAYMESTR0051' | translate }}</button>
          <button (click)="processPayment()"
            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
            'PAYMESTR0018' | translate }}</button> -->
        </div>
      </div>
      }
      }
      }
    </div>
  </div>
</div>

<!-- <div class="card flex justify-center">
  <p-dialog [header]="'PAYMESTR0051' | translate" [modal]="true" [(visible)]="visibleEasypayment"
    styleClass="w-[40vw] 2xl:w-[25vw]">
    <div class="grid grid-cols-3 gap-4 w-full">
      @for (g of easyPayments(); track g.comM_D_CD) {
      <div class="w-full">
        <button (click)="selectedEasyPay(g)"
          class="w-full text-center p-2 rounded-lg transition-colors border text-ellipsis min-w-[100px]"
          [class.font-bold]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
          [class.bg-gray-700]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
          [class.text-white]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
          [class.border-gray-400]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
          [class.shadow-sm]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
          [class.text-gray-800]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
          [class.bg-gray-100]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD"
          [class.border-gray-200]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD"
          [class.text-gray-500]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD"
          [class.hover:bg-gray-200]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD">
          {{ g.comM_D_NM }}
        </button>
      </div>
      }
    </div>
  </p-dialog>
</div> -->